export const AppColors = {
  PRIMARY_COLOR: "#f77e0b",
  RED: "red",
};
